module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"invoice":"Invoice","show invoice PDF":"Show invoice PDF","pay invoice":"pay invoice"},"de":{"invoice":"Rechnung","show invoice PDF":"zeige Rechnungs PDF","pay invoice":"bezahle Rechnung"}}')
  delete Component.options._Ctor
}
